import {
  DefaultButton,
  FontIcon,
  Panel,
  PanelType,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import React, { useCallback, useEffect } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import IdicadorProgress from "../../../../components/generic/IndicadorProgress";
import { MensajeBar } from "../../../../components/generic/ManejoResponseMessage/MessageBar";
import { useCrearArea } from "../../../../hooks/Iperc/Area/useCrearArea";
import COLORES from "../../../../utils/theme/colores";

interface IPanelCrearArea {
  isOpen: boolean;
  onDismiss: () => void;
  modelRequest?: any;
  loadData: () => void;
}

export const PanelCrearArea = (props: IPanelCrearArea) => {
  const {
    isSend,
    response,
    ocultarMensaje,
    onChangeTextField,
    modelrequestCrear,
    handleCrearNuevaArea,
  } = useCrearArea(props.loadData);

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            justifyItems: "center",
            height: "5%",
            padding: "2opx",
            margin: "20px",
          }}
        >
          <div style={{ display: "flex" }}>
            <PrimaryButton
              onClick={() => handleCrearNuevaArea()}
              text="Guardar"
            />
          </div>
          <div style={{ display: "flex" }}>
            <DefaultButton
              onClick={() => {
                props.onDismiss();
              }}
              text={"Salir"}
            />
          </div>
        </div>
      </>
    ),
    [props.onDismiss, handleCrearNuevaArea]
  );
  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"editar"}
          nameIconHeader="FabricNewFolder"
          subTextHeader="Nueva Área Para el Registro de IPERC "
          textHeader="Crear Área"
        />
      </>
    ),
    []
  );
  useEffect(() => {
    if (!props.isOpen) {
      ocultarMensaje();
    }
  }, [props.isOpen]);

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      isFooterAtBottom={true}
      onRenderHeader={onRenderHeaderPanel}
      onRenderFooter={onRenderFooterPanel}
      closeButtonAriaLabel="Close"
      type={PanelType.smallFixedFar}
      isLightDismiss
    >
      <>
        <MensajeBar
          response={response}
          ocultar={() => {
            ocultarMensaje();
          }}
        />

        {isSend === true ? (
          <>
            <IdicadorProgress isSend={isSend} subText="Espere un momento..." />
          </>
        ) : (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-lg12">
              <br />
              <TextField
                label="Nombre de Área:"
                value={modelrequestCrear.nombre}
                onChange={(e, value) => onChangeTextField(e, value)}
                onRenderPrefix={(arg) => (
                  <FontIcon
                    iconName="Rename"
                    style={{ color: COLORES.Bases.primary }}
                  />
                )}
                placeholder="Nombre de Area *"
              />
            </div>
          </div>
        )}
      </>
    </Panel>
  );
};
